import React from 'react';
import { IconButton } from 'rsuite';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import FileDownloadIcon from '@rsuite/icons/FileDownload';

const ExportExcel = ({ excelData, getExcelData, fileName, name, sheetName = 'data', loading = false, disabled = false, onError }) => {
    const fileType = 'application/vnd.openxml formats-officedocument. spreadsheetml. sheet; charset-UTF-8';
    const fileExtension = '.xlsx';
    const [isExporting, setIsExporting] = React.useState(false);

    const exportToExcel = async () => {
        try {
            setIsExporting(true);
            const resolvedData = typeof getExcelData === 'function' ? await getExcelData() : excelData;
            const rows = Array.isArray(resolvedData) ? resolvedData : [];
            const ws = XLSX.utils.json_to_sheet(rows);
            const wb = { Sheets: { [sheetName]: ws }, SheetNames: [sheetName] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, fileName + fileExtension);
        } catch (error) {
            console.error('Error exporting Excel:', error);
            if (typeof onError === 'function') {
                onError(error);
            }
        } finally {
            setIsExporting(false);
        }
    };

    return(
        <>
                <IconButton appearance="primary" color="green" icon={<FileDownloadIcon />} onClick={exportToExcel} loading={loading || isExporting} disabled={disabled || loading || isExporting}>
                {name!== undefined ? name : 'Download Excel'}
                            </IconButton>
        </>
    )

}

export default ExportExcel;
